import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { requestLink } from './actions';
import { selectError, selectMessage, selectSending } from './selectors';
import { Button, Muted } from '../Controls';
import { Page, PageTitle, Panel } from '../Page';
import { ErrorText, Field, Input } from '../Login/styled';

/** Asks for an email with a link to set a new password. */
const ForgotPassword = () => {
  const dispatch = useDispatch();
  const sending = useSelector(selectSending);
  const message = useSelector(selectMessage);
  const error = useSelector(selectError);
  const [email, setEmail] = useState('');

  return (
    <Page>
      <PageTitle>Forgot your password?</PageTitle>
      <Panel>
        {message ? <p role="status">{message}</p> : (
          <form onSubmit={(event) => { event.preventDefault(); dispatch(requestLink(email)); }}>
            <p><Muted>Enter your email and we'll send you a link to set a new password.</Muted></p>
            <Field>
              <label htmlFor="email">Email</label>
              <Input type="email" id="email" autoComplete="username" required value={email} onChange={(event) => setEmail(event.target.value)} />
            </Field>
            {error && <ErrorText role="alert">{error}</ErrorText>}
            <Button $primary $block disabled={sending}>{sending ? 'Sending…' : 'Send the link'}</Button>
          </form>
        )}
        <p><Link to="/login">Back to log in</Link></p>
      </Panel>
    </Page>
  );
};

export default ForgotPassword;
